"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var estimate_reentry_modal_store_1 = __importDefault(require("~/stores/modal/estimate_reentry_modal_store"));
var estimate_fuyo_reentry_modal_store_1 = __importDefault(require("~/stores/modal/estimate_fuyo_reentry_modal_store"));
var EstimateReentryModalStore = /** @class */ (function () {
    function EstimateReentryModalStore(_a) {
        var authenticityToken = _a.authenticityToken, originalEntryId = _a.originalEntryId, showReentryModal = _a.showReentryModal, showFuyoReentryModal = _a.showFuyoReentryModal;
        var _this = this;
        this.handleCloseReentryModal = function () {
            if (_this.showFuyoReentryModal) {
                setTimeout(_this.fuyoReentryModalStore.open, 1000);
            }
        };
        this.showFuyoReentryModal = showFuyoReentryModal;
        this.reentryModalStore = new estimate_reentry_modal_store_1.default({
            authenticityToken: authenticityToken,
            originalEntryId: originalEntryId,
            isOpen: showReentryModal,
            onClose: this.handleCloseReentryModal
        });
        this.fuyoReentryModalStore = new estimate_fuyo_reentry_modal_store_1.default({
            authenticityToken: authenticityToken,
            originalEntryId: originalEntryId,
            isOpen: !this.reentryModalStore.isOpen && showFuyoReentryModal
        });
    }
    return EstimateReentryModalStore;
}());
exports.default = EstimateReentryModalStore;
